exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1[_v-3338d6d4],span.beleive[_v-3338d6d4]{color:#cbda2c!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-3338d6d4&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/pages/content-distributors.vue
 ** module id = 22
 ** module chunks = 0
 **/